export default __webpack_public_path__ + "static/media/17_photo.ce22fc46.jpeg";